import React, { useState } from 'react';
import Navbar from '../../components/Navigation/Navbar';
import { useNavigate } from 'react-router-dom';
import {
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

const StyledPaper = styled(Paper)(({ theme }) => ({
  margin: '100px auto 40px auto',
  maxWidth: 500,
  padding: theme.spacing(6),
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[6],
  backgroundColor: '#fff',
}));

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Use your environment variable here
  const API_URL = process.env.REACT_APP_API_URL;

  const handleLogin = async () => {
  setError('');
  setLoading(true);
  try {
    const res = await fetch(`${API_URL}/login.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    console.log('Response status:', res.status);
    const text = await res.text();  // Get raw response text first
    console.log('Raw response text:', text);

    let data;
    try {
      data = JSON.parse(text);  // Manually parse JSON to catch errors
    } catch (jsonErr) {
      console.error('JSON parse error:', jsonErr);
      setError('Invalid server response. Please contact support.');
      setLoading(false);
      return;
    }

    if (res.ok && data.token) {
      localStorage.setItem('token', data.token);
      navigate('/admin');
    } else {
      setError(data.message || 'Invalid login credentials.');
    }
  } catch (err) {
    console.error('Fetch error:', err);
    setError('An unexpected error occurred. Please try again.');
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      <Navbar />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <StyledPaper>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{ fontWeight: 'bold', color: '#1E88E5' }}
          >
            Login
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <TextField
            label="Email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined"
            autoComplete="off"
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            variant="outlined"
            autoComplete="new-password"
          />

          <Typography
            variant="body2"
            align="right"
            sx={{
              mt: 1,
              mb: 3,
              color: '#1E88E5',
              fontWeight: 500,
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
                color: '#1565C0',
              },
            }}
            onClick={() => navigate('/forget-password')}
          >
            Forgot password?
          </Typography>

          <Button
            variant="contained"
            fullWidth
            onClick={handleLogin}
            disabled={loading}
            sx={{
              mt: 1,
              py: 1.5,
              fontSize: '1rem',
              backgroundColor: '#1E88E5',
              borderRadius: '6px',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#1565C0',
              },
            }}
          >
            Login
          </Button>
        </StyledPaper>
      </motion.div>
    </>
  );
};

export default AdminLogin;
